import { CardType, ICreditCard } from '@/shared/endpoints/customers';
import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';
import MasterIcon from '@/assets/icons/credit-card/master.svg';
import VisaIcon from '@/assets/icons/credit-card/visa.svg';
import AmexIcon from '@/assets/icons/credit-card/amex.svg';
import DiscoverIcon from '@/assets/icons/credit-card/discover.svg';
import { getCreditCardName } from '@/shared/helpers/credit-card';
import Loading from '@/shared/ui/loading';

interface IProps {
    list: ICreditCard[];
    className?: string;
    onChange: (card: ICreditCard) => void;
    loading?: boolean;
}
const cardImages: Record<CardType, string> = {
    visa: VisaIcon,
    mastercard: MasterIcon,
    discover: DiscoverIcon,
    // amex: AmexIcon,
    'american-express': AmexIcon
};

const CardList = ({ list, className = '', onChange, loading = false }: IProps) => {
    const getSourceForCardType = (type: CardType) => cardImages[type] || '';

    return (
        <div className="relative">
            {loading && (
                <div className="absolute inset-0 z-10 flex items-center justify-center rounded-[0.8125rem] bg-mint-800">
                    <Loading size="small" />
                </div>
            )}
            {list.map((card) => {
        const { id, brand, lastFourDigit, expiryMonth, expiryYear } = card;
        const source = getSourceForCardType(brand);
        return (
            <div key={id} className=' py-4 px-5 bg-mint-700 rounded-[0.8125rem]'>
                <div className={`${className} flex w-full flex-rowu items-start  sm:items-center justify-start`} key={id}>
                    {source && (
                        <img
                            width={78}
                            className="card-icon min-w-[4.875rem] mr-4"
                            src={source}
                            alt={brand}
                        />
                    )}

                    <div className="flex w-full flex-col sm-max:gap-[8px] justify-center items-start sm:flex-row sm:justify-between sm:items-center">
                        <div className="flex flex-col">
                            <span className="ph-no-capture">
                                <b>
                                    {getCreditCardName(brand)} ending in {lastFourDigit}
                                </b>
                            </span>
                            <div className="">
                                <span className="expiry ph-no-capture">
                                    Expires {expiryMonth}/{expiryYear}
                                </span>
                            </div>
                        </div>
                        <button
                            onClick={() => onChange(card)}
                            className="underline text-primary font-dmSansBold font-bold leading-[105%] text-17"
                        >
                            Change
                        </button>
                    </div>
                </div>
            </div>
        );
            })}
        </div>
    );
};

export default withScrollRestoration(CardList);
